import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface WelcomePopupProps {
  onClose: () => void;
}

const WelcomePopup: React.FC<WelcomePopupProps> = ({ onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Mostrar el popup con una pequeña animación
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const handleRegisterCompany = () => {
    setIsVisible(false);
    setTimeout(() => {
      // Navegar a la página de registro en lugar de abrir el modal
      navigate('/registro');
      onClose(); // Cerrar el popup
    }, 300);
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      opacity: isVisible ? 1 : 0,
      transition: 'opacity 0.3s ease-in-out'
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderRadius: '20px',
        padding: '30px',
        maxWidth: '400px',
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        transform: isVisible ? 'scale(1)' : 'scale(0.9)',
        transition: 'transform 0.3s ease-in-out'
      }}>
        {/* Icono de bienvenida */}
        <div style={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #20D3C7, #0EA5E9)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 20px',
          boxShadow: '0 10px 20px rgba(32, 211, 199, 0.3)'
        }}>
          <i className="fas fa-hand-wave" style={{
            fontSize: '24px',
            color: 'white'
          }}></i>
        </div>

        {/* Título */}
        <h2 style={{
          margin: '0 0 15px 0',
          fontSize: '24px',
          fontWeight: '600',
          color: '#1F2937',
          lineHeight: '1.3'
        }}>
          ¡Bienvenido a BuenAire!
        </h2>

        {/* Mensaje */}
        <p style={{
          margin: '0 0 25px 0',
          fontSize: '16px',
          color: '#6B7280',
          lineHeight: '1.5'
        }}>
          Encuentra los mejores proveedores de servicios para tu hogar y negocio en Buenos Aires. 
          ¿Tienes una empresa? ¡Registra tu negocio y llega a más clientes!
        </p>

        {/* Botones */}
        <div style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={handleRegisterCompany}
            style={{
              background: 'linear-gradient(135deg, #20D3C7, #0EA5E9)',
              color: 'white',
              border: 'none',
              borderRadius: '25px',
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(32, 211, 199, 0.3)',
              flex: '1',
              minWidth: '140px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(32, 211, 199, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(32, 211, 199, 0.3)';
            }}
          >
            <i className="fas fa-building" style={{ marginRight: '8px' }}></i>
            Registrar Empresa
          </button>

          <button
            onClick={handleClose}
            style={{
              background: 'rgba(255, 255, 255, 0.8)',
              color: '#6B7280',
              border: '1px solid rgba(107, 114, 128, 0.2)',
              borderRadius: '25px',
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              flex: '1',
              minWidth: '140px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 1)';
              e.currentTarget.style.color = '#374151';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.8)';
              e.currentTarget.style.color = '#6B7280';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <i className="fas fa-times" style={{ marginRight: '8px' }}></i>
            Cerrar
          </button>
        </div>

        {/* Texto adicional */}
        <p style={{
          margin: '20px 0 0 0',
          fontSize: '12px',
          color: '#9CA3AF',
          lineHeight: '1.4'
        }}>
          Puedes cerrar este mensaje y explorar libremente. 
          Siempre podrás registrar tu empresa desde el menú principal.
        </p>
      </div>
    </div>
  );
};

export default WelcomePopup;
